import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';

class CalendarYearNew extends React.Component {
  constructor(props) {
    super(props);

    this.handleYearClick = this.handleYearClick.bind(this);
  }

  handleYearClick(e, year) {
    let newDate = this.props.data.displayDate;
    newDate.setFullYear(year);
    const newTerm = `${newDate.getFullYear()}`;
    if (this.props.data.isNohinCalendar) {
      // 納品時期カレンダーの場合
      this.props.comactions.changeCalendarViewMode('month');
    } else {
      // 期間カレンダーの場合
      if (this.props.data.kikanUnit === 'days' ||
        this.props.data.kikanUnit === 'weeks' ||
        this.props.data.kikanUnit === 'months') {
        // viewModeをmonthに切替
        this.props.comactions.changeCalendarViewMode('month');
      } else if (this.props.data.kikanUnit === 'years') {
        // 期間を選択してカレンダーを閉じる
        if (this.props.isExec) {
          this.props.comactions.changeKikanTerm(newTerm, null, null, newDate);
        } else {
          // 画面リロードしない場合はカレンダーを閉じる
          this.props.handleCancel(e);
        }
      }
    }
  }

  render() {
    const currentDate = this.props.data.displayDate;
    let term;
    if (this.props.data.isNohinCalendar) {
      term = new Date(this.props.data.nohinTermData.data[0].model.nohinkaishibi);
    } else {
      if (this.props.data.kikanUnit == 'weeks') {
        let termDataIndex = this.props.data.termData.findIndex(item => item.id == this.props.data.term);
        if (termDataIndex == 0) {
          term = new Date(this.props.data.termData[0].from_date);
        } else {
          let weekValues = commonLogic.getWeekStartAndEnd(this.props.data.term, 7, 3);
          term = new Date(weekValues[weekValues.length - 1]);
        }
      } else {
        term = commonLogic.formatTermToDate(this.props.data.term, this.props.data.calendarViewMode, this.props.data.kikanUnit, this.props.data.termData);
      }
    }
    if (currentDate) {
      const startYear = Math.floor(currentDate.getFullYear() / 10) * 10;
      const years = Array.from({ length: 10 }, (_, i) => String(startYear + i));
      const termDataList = this.props.data.termData;
      const isCalendarViewModeHeaderEvent = this.props.data.isCalendarViewModeHeaderEvent;
      const kikanUnit = this.props.data.kikanUnit;
      const currentNohinTerm = this.props.data.isFromDatePicker ? this.props.data.nohinkaishibiFrom : this.props.data.nohinkaishibiTo;
      let currentNohinDate = null;

      if (currentNohinTerm != null && currentNohinTerm != undefined && currentNohinTerm != '') {
        currentNohinDate = new Date(currentNohinTerm);
      }

      return (
        <div className="date-picker-years-body">
          {years.map((year, index) => {
            let className = 'year';
            let canSelect = false;
            let isSelected = false;
            if (this.props.data.isNohinCalendar) {
              // 納品時期カレンダーの場合
              const nohinData = this.props.data.nohinTermData;
              const recentNohinDate =  new Date(nohinData.data[0].model.nohinkaishibi);
              const tgtDate = new Date(year, 0);
              canSelect = currentDate.getFullYear() >= 2010 && recentNohinDate.getFullYear() >= tgtDate.getFullYear();
              if (currentNohinDate != null) {
                isSelected = currentNohinDate.getFullYear() == Number(year);
              }
            } else {
              // 期間カレンダーの場合
              let yearDate = new Date(year, '01');
              if (isCalendarViewModeHeaderEvent) {
                // カレンダーUIのヘッダから表示された場合
                canSelect = termDataList.some((item) => {
                  let itemDate;
                  let flg;
                  if (kikanUnit == 'days') {
                    itemDate = new Date(commonLogic.formatDate(item.id, 3));
                    flg = (itemDate.getFullYear() == yearDate.getFullYear());
                  } else if (kikanUnit == 'weeks') {
                    let weekRangeList = commonLogic.getWeekStartAndEnd(item.id, 7, 3);
                    let ymdFrom = weekRangeList[0];
                    let ymdTo = weekRangeList[weekRangeList.length - 1];
                    let itemDateFrom = new Date(ymdFrom);
                    let itemDateTo = new Date(ymdTo);
                    flg = (itemDateFrom.getFullYear() == yearDate.getFullYear()) || (itemDateTo.getFullYear() == yearDate.getFullYear());
                  } else {
                    itemDate = new Date(item.id);
                    flg = (itemDate.getFullYear() == yearDate.getFullYear());
                  }

                  return flg;
                });
              } else {
                // 絞り込み条件から表示された場合
                canSelect = termDataList.some(item => item.id == year);
              }
              isSelected = Number(year) === term.getFullYear();
            }
            if (!canSelect) {
              className += ' no_data';
            } else {
              if (isSelected) {
                className += ' selected';
              }
            }

            return (
              <div key={year} className={className} style={{ order: index }}
                onClick={canSelect ? e => this.handleYearClick(e, year) : null}
              >
                {year}年
              </div>
            );
          })}
        </div>
      );
    }
  }
}

CalendarYearNew.propTypes = {
  data: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  isExec: PropTypes.any.isRequired
};

export default CalendarYearNew;
